<div class="card bg-white p-3">
        <div class="row">
            <div class="col-12">
                <app-status-bar [listOfProcesses]="listOfProcesses"></app-status-bar>
            </div>
        </div>
    </div>
